export { default } from './LayoutHeaderSearchBox';
